import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { wilsonConfig } from "./data";

export default function WilsonPage() {
  return <CityPageTemplate config={wilsonConfig} />;
}